<template>
  <div class="modal" v-bind:class="{ 'is-active': is_shown }">
    <div class="modal-background" @click="close_modal"></div>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">{{ $t("edit user") }}</p>
        <button class="delete" aria-label="close" @click="close_modal"></button>
      </header>
      <section class="modal-card-body">
        <div class="tabs is-toggle is-fullwidth" ref="tabs">
          <ul>
            <li class="is-active" data-tab="general" @click="change_active_tab">
              <a>
                <i class="info icon" aria-hidden="true"></i>
                <span>{{ $t("general") }}</span>
              </a>
            </li>
            <li data-tab="settings" @click="change_active_tab">
              <a>
                <i class="settings icon" aria-hidden="true"></i>
                <span>{{ $t("settings") }}</span>
              </a>
            </li>
          </ul>
        </div>
        <div class="container is-fluid" ref="contents">
          <div class="" data-tab="general">
            <form>
              <div class="columns">
                <div class="column">
                  <div class="field">
                    <label class="label">{{ $t("username") }}</label>
                    <div class="control">
                      <input
                        class="input"
                        type="text"
                        v-model="meta.username"
                      />
                    </div>
                  </div>
                </div>
                <div class="column">
                  <figure
                    class="image is-128x128 m-auto py-3"
                    v-if="
                      meta.photo &&
                      meta.photo.settings &&
                      meta.photo.settings.final_name
                    "
                  >
                    <v-lazy-image
                      :src="`${api_host}/drive/static/${meta.photo.settings.final_name}`"
                    />
                  </figure>
                  <generic-uploader
                    ref="generic_uploader"
                    :idle_label="$t('drop user photo here')"
                    endpoint_url="/access/user/photo"
                    :extra_data="{ uuid: uuid }"
                    :allow_multiple="false"
                    @error="error_uploading"
                    @success="success_uploading"
                  />
                </div>
              </div>

              <div class="field">
                <label class="label">{{ $t("email") }}</label>
                <div class="control">
                  <input class="input" type="email" v-model="meta.email" />
                </div>
              </div>
              <div class="field">
                <generic-dropdown
                  :title="$t('roles')"
                  :placeholder="$t('roles')"
                  url="/access/role/catalog"
                  name_field="name"
                  value_field="role_id"
                  @change="set_roles"
                  ref="roles_dropdown"
                />
              </div>
            </form>
          </div>
          <div class="is-hidden" data-tab="settings">
            <form>
              <div class="columns">
                <div class="column">
                  <div class="field">
                    <label class="label">{{ $t("default language") }}</label>
                    <div class="control">
                      <div class="select">
                        <select v-model="meta.settings.default_language">
                          <option value="es">{{ $t("spanish") }}</option>
                          <option value="en">{{ $t("english") }}</option>
                          <option value="fr">{{ $t("french") }}</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="column">
                  <div class="field">
                    <label class="label">{{ $t("default theme") }}</label>
                    <div class="control">
                      <div class="select">
                        <select v-model="meta.settings.default_theme">
                          <option value="dark">{{ "System Dark" }}</option>
                          <option value="light">{{ "System Light" }}</option>
                          <option value="cerulean">{{ "Cerulean" }}</option>
                          <option value="cosmo">{{ "Cosmo" }}</option>
                          <option value="cyborg">{{ "Cyborg" }}</option>
                          <option value="darkly">{{ "Darkly" }}</option>
                          <option value="flatly">{{ "Flatly" }}</option>
                          <option value="journal">{{ "Journal" }}</option>
                          <option value="litera">{{ "Litera" }}</option>
                          <option value="lumen">{{ "Lumen" }}</option>
                          <option value="lux">{{ "Lux" }}</option>
                          <option value="materia">{{ "Materia" }}</option>
                          <option value="minty">{{ "Minty" }}</option>
                          <option value="pulse">{{ "Pulse" }}</option>
                          <option value="sandstone">{{ "Sandstone" }}</option>
                          <option value="simplex">{{ "Simplex" }}</option>
                          <option value="slate">{{ "Slate" }}</option>
                          <option value="solar">{{ "Solar" }}</option>
                          <option value="spacelab">{{ "Spacelab" }}</option>
                          <option value="superhero">{{ "Superhero" }}</option>
                          <option value="united">{{ "United" }}</option>
                          <option value="yeti">{{ "Yeti" }}</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
        <div class="notification is-danger mt-5" v-if="error">
          <p v-html="error"></p>
        </div>
      </section>
      <footer class="modal-card-foot">
        <p class="buttons">
          <button
            class="button is-primary is-rounded"
            :disabled="is_form_valid"
            @click="save"
          >
            <span class="icon">
              <i class="fa fa-save"></i>
            </span>
            <span>{{ $t("save") }}</span>
          </button>
          <button class="button is-rounded" @click="close_modal">
            {{ $t("cancel") }}
          </button>
        </p>
      </footer>
    </div>
  </div>
</template>
<script>
import { get, post, generate_error_message_text, api_host } from "@/utils";
import GenericDropdown from "@/components/generic_dropdown/Index.vue";
import GenericUploader from "@/components/generic_uploader/Index.vue";
import VLazyImage from "v-lazy-image";

export default {
  name: "EditUserModal",
  components: { GenericDropdown, GenericUploader, VLazyImage },
  data() {
    return {
      is_shown: false,
      meta: { settings: {} },
      uuid: "",
      error: "",
    };
  },
  computed: {
    api_host() {
      return api_host;
    },
    is_form_valid() {
      let v = this;
      return !v.meta.username || !v.meta.email;
    },
  },
  methods: {
    close_modal() {
      let v = this;
      v.is_shown = false;
      v.set_initial_state();
    },
    show_modal(uuid) {
      let v = this;
      v.set_initial_state();
      get("/access/user", { uuid: uuid })
        .then((usr) => {
          // v.meta = usr;
          if (usr && usr.email) v.meta.email = usr.email;
          if (usr && usr.username) v.meta.username = usr.username;
          if (usr && usr.settings) {
            v.meta.settings = usr.settings;
          }

          if (
            usr &&
            usr.system_role_suscriptions &&
            usr.system_role_suscriptions.length
          ) {
            let vls = usr.system_role_suscriptions.map((s) => {
              return s.role_id;
            });
            v.$refs.roles_dropdown.set_value(vls);
          }

          if (usr && usr.photo) {
            v.meta.photo = usr.photo;
          } else {
            v.meta.photo = {};
          }

          v.uuid = uuid;
          v.is_shown = true;
        })
        .catch((error) => {
          v.error = generate_error_message_text(error);
        });
    },
    save() {
      let v = this;
      let obj = { ...v.meta };
      obj.uuid = v.uuid;
      post("/access/user", obj)
        .then(() => {
          v.$emit("success");
          v.close_modal();
        })
        .catch((error) => {
          v.error = generate_error_message_text(error);
        });
    },
    set_initial_state() {
      let v = this;
      v.meta = {
        username: "",
        email: "",
        roles: "",
        settings: {},
      };
      v.$refs.roles_dropdown.clear();
      v.$refs.generic_uploader.clear();
      v.uuid = "";
      v.error = "";
    },
    change_active_tab($event) {
      let v = this;
      let target = $event.target;
      let active_tab = "";
      if (target) active_tab = window.jQuery(target).closest("li").data("tab");
      if (active_tab) {
        /** Headers */
        window.jQuery(v.$refs.tabs).find("li").removeClass("is-active");
        window
          .jQuery(v.$refs.tabs)
          .find(`li[data-tab=${active_tab}]`)
          .addClass("is-active");

        /** Content */
        window.jQuery(v.$refs.contents).find(">div").addClass("is-hidden");
        // .attr("display", "none");
        window
          .jQuery(v.$refs.contents)
          .find(`div[data-tab=${active_tab}]`)
          .removeClass("is-hidden");
      }
    },
    set_roles(value) {
      let v = this;
      v.meta.roles = value;
    },
    error_uploading(error) {
      console.error(error);
    },
    success_uploading(response) {
      let v = this;
      let r = JSON.parse(response.serverId);
      v.meta.photo = r;
      // v.comparisson_result = r;
      // v.$refs.generic_uploader.clear();
      // let rspnse = JSON.parse(response.serverId);
      // let data = {
      //   final_name: rspnse.final_name,
      //   filepath: rspnse.filepath,
      // };
      // v.meta.photo = data;
    },
  },
  mounted() {},
};
</script>
<style></style>
